import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components/lib/Button';
import {useTranslation} from 'react-i18next';

import style from './style.module.scss';

const TRANSLATION_KEY = `Skip.string`;

export function SkipButton(props) {
  const {
    t,
    //i18l
  } = useTranslation();
  const BUTTON_TEXT = t(TRANSLATION_KEY);

  const className = props.disabled
    ? `${style.skipButton_inactive}`
    : `${style.skipButton_active}`;

  return (
    <Button
      className={className}
      onClick={props.onClick}
      tabIndex={props.tabIndex}>
      {BUTTON_TEXT}
    </Button>
  );
}

SkipButton.propTypes = {
  /**
   * Disabled is a boolen which stores the component is working or not
   */
  disabled: PropTypes.bool,
  /**
   * Which is used for keyboard navigation
   */
  tabIndex: PropTypes.number,
  /**
   * callback function to invoke on button press
   */
  onClick: PropTypes.func,
};
SkipButton.defaultProps = {};
